var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.fill ? 'position: relative; height: 100%;' : 'position: relative; min-height: 400px;')},[(_vm.isRendering)?_c('div',{staticClass:"chart-loading"},[_c('i',{staticClass:"tim-icons icon-refresh-01 chart-spin"})]):_vm._e(),_c('canvas',{ref:"lineChart",class:{ 'chart-hidden': _vm.isRendering, 'chart-canvas-fill': _vm.fill }})])
}
var staticRenderFns = []

export { render, staticRenderFns }